"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateForSegment = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
require("dayjs/locale/fr");
require("dayjs/locale/en-gb");
const constants_1 = require("./constants");
dayjs_1.default.extend(advancedFormat_1.default);
const formatDateForSegment = (date, segment, format = 'Do MMMM, YYYY') => {
    if ((0, dayjs_1.default)(date).isValid() === false)
        return date;
    switch (segment) {
        case constants_1.Segment.Fixter_UK:
            return (0, dayjs_1.default)(date).locale('en-gb').format(format);
        case constants_1.Segment.Fixter_FR:
            return (0, dayjs_1.default)(date).locale('fr').format(format);
        default:
            return (0, dayjs_1.default)(date).locale('en-gb').format(format);
    }
};
exports.formatDateForSegment = formatDateForSegment;
//# sourceMappingURL=date.js.map